import { CheckPicker, Input } from "rsuite";
import Responsive from "../../../Components/Responsive";
import Extrats from "../Extrats/Extrats.component";
import { CaracteristiquePackageVoTranslations } from "../../../Constants/types";
import Caracteristique from "../../../Components/Caracteristique/caracteristique";
import { APi } from "../../../Api";
import { useEffect, useState } from "react";
import Translation from "../../../translation/translation";

const InformationsGeneral = ({
  setModel,
  providers,
  fetchProviders,
  model,
}) => {
  const setCaracteristiques = (caracteristique) => {
    setModel((prev) => ({
      ...prev,
      caracteristique,
    }));
  };
  const [categories, setCategories] = useState([]);

  const fetchCategories = () => {
    APi.createAPIEndpoint(`${APi.ENDPOINTS.Category}/GetFiltreData`, { isUmrah: false })
      .fetchAll()
      .then((res) => {
        setCategories(res.data.categories);
      })
      .catch((e) => {
        console.log("e", e);
      });
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleChangeCategories=(categories) => {
    {
      setModel((prev) => ({ ...prev, categoryIds: categories }));
    }
  }

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <Responsive m={6} l={6} xl={6} className="p-10">
          <label>Nom :</label>
          <Input
            value={model.name}
            onChange={(name) =>
              setModel((prev) => ({ ...prev, name: name.toUpperCase() }))
            }
          />
        </Responsive>

        <Responsive m={6} l={6} xl={6} className="p-10">
          <label>Description :</label>
          <Input
            value={model.description}
            onChange={(description) =>
              setModel((prev) => ({ ...prev, description }))
            }
          />
        </Responsive>
        <Responsive s={4} m={3} l={2} xl={2} className="p-10">
        <label>{Translation.categories} :</label>
        <div className="p-2 font-sans">
            <CheckPicker
              value={model.categoryIds || []}
              data={categories.map((c) => ({ label: c.name, value: c.id }))}
              block
              noSearch
              onChange={handleChangeCategories}
              placeholder={Translation.chooseCategories}
            />
          </div>
        </Responsive>
      </div>

      <Caracteristique
        setCaracteristiques={setCaracteristiques}
        caracteristique={model.caracteristique || {}}
        translations={CaracteristiquePackageVoTranslations}
      />

      <Extrats
        providers={providers}
        fetchProviders={fetchProviders}
        model={model}
        setModel={setModel}
      />
    </div>
  );
};

export default InformationsGeneral;
